module.exports = __webpack_public_path__ + "img/logo.b9fecef2.jpg";